import {DisplayName} from '@yasc/yasc-material-components';

export class BankAccountRes {
    public guid!: string;
    public accountOwner!: string;
    public bankName!: string;
    public iban!: string;
    public bic!: string;
    public default!: boolean;
    public billingAccountOnly!: boolean;
    public finApiBankId?: number;

    constructor(account?: BankAccountRes) {
        if (account === undefined) return;

        this.accountOwner = account.accountOwner;
        this.bankName = account.bankName;
        this.iban = account.iban;
        this.bic = account.bic;
        this.guid = account.guid;
        this.default = account.default;
        this.billingAccountOnly = account.billingAccountOnly;
        this.finApiBankId = account.finApiBankId;
    }

    toString(): string {
        return `IBAN: ${this.iban}\nBic: ${this.bic}`;
    }
}

export class TaxOfficeDetailsRes {
    id?: number;
    @DisplayName('general_name')
    name: string = '';
}

export class CourtOfficeDetailsRes {
    id?: number;
    @DisplayName('general_name')
    name: string = '';
    @DisplayName('general_nr')
    nr: string = ''
}